/* V4 pre-owned clarification. Read-only data; insert ONE node inside a full description. */
(function () {
  'use strict';
  if (window.GBEProductConditionNoteV4) { window.GBEProductConditionNoteV4.refresh(); return; }
  var sourceSelector = 'template[data-gbe-preowned-source]';
  var noteSelector = '[data-gbe-preowned-note]';
  var cache = new WeakMap();
  var ignored = 'script,style,template,noscript,details,[hidden],[aria-hidden="true"],.d-none,.faq,.faq-dropdown,.faq-item,[class*="faq-"],[class*="faqs"],[data-gbe-preowned-note]';
  var unsafe = 'table,thead,tbody,tfoot,tr,td,th,ul,ol,li,dl,dt,dd,a,button,form,details';

  function norm(value) {
    return String(value || '').normalize('NFKC').toLowerCase()
      .replace(/[\u200b-\u200d\ufeff]/g, '').replace(/[\u2010-\u2015\u2212-]/g, ' ')
      .replace(/\s+/g, ' ').trim();
  }
  function text(node) { return norm(node && node.textContent); }
  function cleanLabel(value) { return norm(value).replace(/^[^a-z0-9]+|[^a-z0-9]+$/g, ''); }
  function isLabel(value) { return /^(?:(?:product|item|part|board) )?condition$/.test(cleanLabel(value)); }
  function excluded(node) {
    // An inactive description tab remains a valid destination; its internal hidden content does not.
    for (var n = node; n && n.nodeType === 1; n = n.parentElement) {
      if (n.matches('.js-tab-content')) return false;
      if (n.matches(ignored)) return true;
    }
    return false;
  }
  function classify(value) {
    var s = norm(value);
    if (/\b(?:not|never)\s+(?:a\s+)?pre\s*owned\b/.test(s)) return 'other';
    var preowned = /\bpre\s*owned\b/.test(s);
    // Mask explicit negatives, NOT positive new/repaired/refurbished statements.
    var words = '(?:new|refurbished|repaired|reconditioned|remanufactured)';
    var negation = new RegExp('\\b(?:not|never|neither|non|without)\\s+(?:(?:a|an|been|brand|factory)\\s+)*' + words + '(?:\\s*(?:or|nor|and|,|/)\\s*' + words + ')*', 'g');
    var positive = s.replace(negation, '');
    if (/\b(?:new|refurbished|repaired|reconditioned|remanufactured)\b/.test(positive)) return preowned ? 'conflict' : 'other';
    if (/\b(?:may|might|either|possibly|unknown|unspecified)\b|\?/.test(s)) return 'unclear';
    return preowned ? 'preowned' : 'unclear';
  }
  function alreadyIn(node) {
    if (node.querySelector(noteSelector)) return true;
    var copy = node.cloneNode(true);
    copy.querySelectorAll(ignored).forEach(function (n) { n.remove(); });
    var s = text(copy);
    return /product condition\s*:\s*pre\s*owned\s*\(not new\)/.test(s) &&
      s.indexOf('this is a 100% original part removed from a working tv unit. it is not refurbished or repaired.') !== -1;
  }
  function assess(html) {
    var inert = document.createElement('template');
    inert.innerHTML = html;
    var fragment = inert.content;
    var existing = alreadyIn(fragment);
    fragment.querySelectorAll(ignored).forEach(function (n) { n.remove(); });
    var values = [];
    fragment.querySelectorAll('tr').forEach(function (row) {
      var cells = Array.prototype.filter.call(row.children, function (n) { return /^(TD|TH)$/.test(n.tagName); });
      if (cells.length === 2 && isLabel(cells[0].textContent)) values.push(cells[1].textContent);
    });
    fragment.querySelectorAll('dt').forEach(function (dt) {
      var dd = dt.nextElementSibling;
      if (isLabel(dt.textContent) && dd && dd.tagName === 'DD') values.push(dd.textContent);
    });
    fragment.querySelectorAll('p,li,div,h2,h3,h4,h5,h6').forEach(function (n) {
      // A wrapper containing whole paragraphs or a table is not a condition statement.
      if (n.querySelector('p,div,table,dl,ul,ol,h2,h3,h4,h5,h6')) return;
      var s = text(n);
      if (s.length > 350) return;
      var match = s.match(/^(?:(?:product|item|part|board)\s+)?condition\s*(?::|=|\s)\s*(.+)$/);
      if (match) values.push(match[1]);
      else if (isLabel(s) && n.nextElementSibling && /^(P|DIV|SPAN|STRONG)$/.test(n.nextElementSibling.tagName) && text(n.nextElementSibling).length < 220) values.push(n.nextElementSibling.textContent);
      else if (/^this(?:\s+(?:product|item|part|board|unit|module|cable))?\s+(?:is|was|has been)\s+/.test(s) && /\b(?:pre\s*owned|new|refurbished|repaired|reconditioned|remanufactured)\b/.test(s)) values.push(s);
    });
    if (!fragment.children.length) {
      var plain = text(fragment).match(/^(?:(?:product|item|part|board)\s+)?condition\s*:\s*(.+)$/);
      if (plain) values.push(plain[1]);
    }
    if (!values.length) return { eligible: false, reason: 'no-explicit-condition', existing: existing };
    var states = values.map(classify);
    if (states.indexOf('conflict') !== -1 || (states.indexOf('preowned') !== -1 && states.indexOf('other') !== -1)) return { eligible: false, reason: 'conflicting-condition', existing: existing };
    if (states.indexOf('other') !== -1) return { eligible: false, reason: 'new-refurbished-repaired-or-not-preowned', existing: existing };
    if (states.indexOf('unclear') !== -1) return { eligible: false, reason: 'unclear-condition', existing: existing };
    return { eligible: true, reason: 'explicit-preowned', existing: existing };
  }
  function decision(source) {
    var json = source.content.querySelector('[data-gbe-condition-html]');
    var raw = json ? json.textContent : '';
    var previous = cache.get(source);
    if (previous && previous.raw === raw) return previous.result;
    var result;
    try {
      var html = JSON.parse(raw);
      result = typeof html === 'string' ? assess(html) : { eligible: false, reason: 'invalid-source' };
    } catch (_) { result = { eligible: false, reason: 'invalid-source' }; }
    cache.set(source, { raw: raw, result: result });
    return result;
  }
  function heading(node) {
    if (!node || excluded(node)) return false;
    if (/^H[1-6]$/.test(node.tagName)) return true;
    if (!/^(DIV|P)$/.test(node.tagName) || node.querySelector('p,div,table,ul,ol') || text(node).length > 85) return false;
    return /^(?:testing|quality|packing|installation guidance|assurance of originality|benefits of using original parts|compatibility|product image)$/.test(cleanLabel(node.textContent));
  }
  function testingParagraph(testing) {
    for (var next = testing.nextElementSibling; next && !heading(next); next = next.nextElementSibling) {
      if (excluded(next)) continue;
      if (next.tagName === 'P') return next;
      var paragraph = next.querySelector('p');
      if (paragraph && !excluded(paragraph)) return paragraph;
    }
    return null;
  }
  function matchTestingStyle(note, slot) {
    if (note.getAttribute('data-gbe-condition-layout') !== 'default' || !slot.testing) return;
    var headingNode = note.querySelector('.gbe-condition-note__heading');
    var typography = ['font-family', 'font-size', 'font-weight', 'font-style', 'line-height', 'letter-spacing', 'word-spacing', 'color', 'text-transform', 'text-align'];
    var spacing = ['margin-top', 'margin-right', 'margin-bottom', 'margin-left', 'padding-top', 'padding-right', 'padding-bottom', 'padding-left'];
    function copy(target, reference, properties) {
      if (!target || !reference) return;
      var computed = window.getComputedStyle(reference);
      properties.forEach(function (property) {
        var value = computed.getPropertyValue(property);
        if (target.style.getPropertyValue(property) !== value) target.style.setProperty(property, value);
      });
    }
    copy(headingNode, slot.testing, typography.concat(spacing, ['background-color', 'border-radius']));
    if (slot.paragraph) note.querySelectorAll('.gbe-condition-note__copy > p').forEach(function (paragraph) {
      copy(paragraph, slot.paragraph, typography.concat(spacing));
    });
  }
  function defaultSlot(root) {
    var panels = Array.prototype.filter.call(root.querySelectorAll('.js-product-tabs .js-tab-content[id]'), function (n) {
      return !/^tab-content-(?:page-|review|accessories|metafield-)/.test(n.id);
    });
    for (var i = 0; i < panels.length; i += 1) {
      var panel = panels[i];
      var headings = Array.prototype.filter.call(panel.querySelectorAll('h2,h3,h4,h5,h6,div,p'), heading);
      for (var j = 0; j < headings.length; j += 1) {
        var testing = headings[j];
        if (!/^(?:product )?testing$/.test(cleanLabel(testing.textContent))) continue;
        if (testing.closest(unsafe)) continue;
        var next = testing.nextElementSibling;
        while (next && !heading(next)) next = next.nextElementSibling;
        if (next && !next.closest(unsafe)) return { parent: next.parentNode, before: next, area: panel, reason: 'after-testing', testing: testing, paragraph: testingParagraph(testing) };
        var group = testing.parentElement;
        if (group !== panel && group && group.nextElementSibling && !group.closest(unsafe)) return { parent: group.parentNode, before: group.nextElementSibling, area: panel, reason: 'after-testing-section', testing: testing, paragraph: testingParagraph(testing) };
        return { parent: testing.parentNode, before: null, area: panel, reason: 'after-testing', testing: testing, paragraph: testingParagraph(testing) };
      }
      // <h5> headings are already converted into tabs by the existing Liquid code.
      var control = Array.prototype.find.call(root.querySelectorAll('.js-tab-control'), function (n) { return n.getAttribute('data-target') === '#' + panel.id && cleanLabel(n.textContent) === 'testing'; });
      if (control && text(panel).length > 20) return { parent: panel, before: null, area: panel, reason: 'end-of-testing-tab' };
    }
    // Safe whole-block fallback near the middle; never split a table, list or paragraph.
    var best = null;
    panels.forEach(function (panel) {
      var containers = [panel].concat(Array.prototype.filter.call(panel.querySelectorAll('div,section,article'), function (n) {
        return !excluded(n) && !n.closest(unsafe) && n.children.length >= 4;
      }));
      containers.forEach(function (parent) {
        if (excluded(parent) || parent.closest(unsafe)) return;
        var nodes = Array.prototype.filter.call(parent.children, function (n) { return !excluded(n) && text(n).length > 0; });
        if (nodes.length < 4) return;
        var sizes = nodes.map(function (n) { var c = n.cloneNode(true); c.querySelectorAll(ignored).forEach(function (x) { x.remove(); }); return text(c).length; });
        var total = sizes.reduce(function (a, b) { return a + b; }, 0), before = 0;
        nodes.forEach(function (n, index) {
          var after = total - before, ratio = before / total;
          if (index > 0 && before >= 80 && after >= 80 && ratio >= 0.3 && ratio <= 0.7 && !heading(nodes[index - 1]) && !n.closest(unsafe)) {
            var score = Math.abs(0.5 - ratio);
            if (!best || score < best.score) best = { parent: parent, before: n, area: panel, reason: 'safe-middle-boundary', score: score };
          }
          before += sizes[index];
        });
      });
    });
    return best;
  }
  function dynamicSlot(root, page) {
    var model = root.hasAttribute('data-gbe-model-product-root');
    var area = page.querySelector(model ? '.gbe-model-details' : '.gbe-product-description');
    var content = area && area.querySelector('.gbe-content');
    if (!content) return null;
    var assurance = model ? 'model-assurance-' : 'gbe-assurance-title-';
    var matching = model ? 'model-match-' : 'gbe-matching-title-';
    var items = Array.prototype.slice.call(content.children);
    var find = function (key) { return items.find(function (n) { return (n.getAttribute('aria-labelledby') || '').indexOf(key) === 0; }); };
    var anchor = find(assurance) || find(matching);
    return anchor ? { parent: content, before: anchor.nextSibling, area: area, reason: find(assurance) ? 'after-assurance' : 'after-assurance-slot-hidden' } : null;
  }
  function ensureDynamicConditionRow(root, page) {
    var model = root.hasAttribute('data-gbe-model-product-root');
    var spare = root.hasAttribute('data-gbe-tv-spare-product-root');
    if (!model && !spare) return;
    var area = page.querySelector(model ? '.gbe-model-details' : '.gbe-product-description');
    var list = area && area.querySelector('.gbe-content .gbe-spec-list');
    if (!list) return;
    var rows = Array.prototype.slice.call(list.querySelectorAll(':scope > .gbe-spec-row'));
    var existing = rows.find(function (row) {
      var dt = row.querySelector(':scope > dt');
      return dt && cleanLabel(dt.textContent) === 'condition';
    });
    if (existing) return;
    var partRow = rows.find(function (row) {
      var dt = row.querySelector(':scope > dt');
      return dt && cleanLabel(dt.textContent) === 'part type';
    });
    if (!partRow) return;
    var conditionRow = document.createElement('div');
    conditionRow.className = 'gbe-spec-row';
    conditionRow.setAttribute('data-gbe-condition-spec-row', 'preowned');
    var dt = document.createElement('dt');
    dt.textContent = 'Condition';
    var dd = document.createElement('dd');
    dd.textContent = 'Pre-Owned';
    conditionRow.appendChild(dt);
    conditionRow.appendChild(dd);
    partRow.insertAdjacentElement('afterend', conditionRow);
  }
  function refresh() {
    document.querySelectorAll(sourceSelector).forEach(function (source) {
      var root = document.getElementById(source.getAttribute('data-gbe-condition-root'));
      var page = root && root.closest('.page-product-template');
      if (!page || !root.hasAttribute('data-gbe-default-product-root')) return;
      var key = source.getAttribute('data-gbe-condition-key');
      var id = 'gbe-preowned-note-' + key;
      var existing = document.getElementById(id);
      var state = decision(source);
      function status(value) { source.setAttribute('data-gbe-condition-status', value); }
      if (state.eligible) ensureDynamicConditionRow(root, page);
      if (!state.eligible || state.existing) {
        if (existing && existing.matches(noteSelector)) existing.remove();
        status(state.existing ? 'already-in-product-description' : state.reason);
        return;
      }
      var dynamic = root.hasAttribute('data-gbe-model-product-root') || root.hasAttribute('data-gbe-tv-spare-product-root');
      var slot = dynamic ? dynamicSlot(root, page) : defaultSlot(root);
      if (!slot) { status('no-safe-description-position'); return; }
      if (existing && slot.area.contains(existing)) { matchTestingStyle(existing, slot); status('inserted'); return; }
      if (alreadyIn(slot.area)) { status('existing-description-note'); return; }
      if (existing && !existing.matches(noteSelector)) { status('conflicting-note-id'); return; }
      if (existing) existing.remove();
      var pattern = source.content.querySelector(noteSelector);
      if (!pattern) { status('missing-note-template'); return; }
      var note = pattern.cloneNode(true);
      note.id = id;
      note.setAttribute('data-gbe-preowned-owner', source.getAttribute('data-gbe-condition-root'));
      note.setAttribute('data-gbe-condition-position', slot.reason);
      slot.parent.insertBefore(note, slot.before);
      matchTestingStyle(note, slot);
      status('inserted');
    });
  }
  window.GBEProductConditionNoteV4 = {
    refresh: refresh,
    getReport: function () {
      return Array.prototype.map.call(document.querySelectorAll(sourceSelector), function (s) {
        return { productId: s.getAttribute('data-gbe-condition-product'), section: s.getAttribute('data-gbe-condition-root'), status: s.getAttribute('data-gbe-condition-status') || 'pending' };
      });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
  window.addEventListener('load', refresh, { once: true });
  var resizeFrame = 0;
  window.addEventListener('resize', function () {
    if (resizeFrame) return;
    resizeFrame = window.requestAnimationFrame(function () { resizeFrame = 0; refresh(); });
  });
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll(sourceSelector).forEach(function (source) {
      var node = document.getElementById('gbe-preowned-note-' + source.getAttribute('data-gbe-condition-key'));
      if (node && node.matches(noteSelector)) node.remove();
    });
  });
})();
